var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"batch-size-warning"},[_c('i',{staticClass:"fas fa-info-circle mr-1"}),_c('span',[_vm._v(" Số lượng lớn ("+_vm._s(_vm.count)+" hóa đơn). Nên dùng chế độ "),_c('strong',[_vm._v("\"Dùng chung\"")]),_vm._v(" hoặc tách thành nhiều đợt nhỏ hơn (~"+_vm._s(_vm.threshold)+"/đợt). ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }